module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu4mxK.479970ff.woff2";